import {
  MAKE_FAC_PAYMENT_API_REQUEST,
  MAKE_FAC_PAYMENT_API_SUCCESS,
  MAKE_FAC_PAYMENT_API_ERROR,
  MAKE_FAC_PAYMENT_SUCCESS,
} from '../../../constants/cartActionNames';

import { cartApi } from '../../../apis/cart';

function makeFACPaymentApiRequest() {
  return {
    type: MAKE_FAC_PAYMENT_API_REQUEST,
    payload: true,
  };
}

function makeFACPaymentApiSuccess(cart, params) {
  return {
    type: MAKE_FAC_PAYMENT_API_SUCCESS,
    payload: cart,
    params,
  };
}

function makeFACPaymentApiError(err) {
  return {
    type: MAKE_FAC_PAYMENT_API_ERROR,
    payload: err,
  };
}

export function makeFACPaymentAction(params) {
  return (dispatch, getState) => {
    const state = getState();
    dispatch(makeFACPaymentApiRequest());
    return cartApi
      .fac(state, params)
      .then(data => {
        dispatch(makeFACPaymentApiSuccess(data, params));
        return data;
      })
      .catch(error => {
        dispatch(makeFACPaymentApiError(error));
        throw error;
      });
  };
}

export default { makeFACPaymentAction };
